import { AppBar, Box, Toolbar } from '@mui/material';
import React, { Fragment, JSXElementConstructor, ReactElement } from 'react';

interface HeaderBarProps {
  headerChildren: (ReactElement<any, string | JSXElementConstructor<any>> | ReactElement<any, string | JSXElementConstructor<any>>[])[];
  className: string;
  currentHeaderRef: React.RefObject<any>;
  id: string;
  position?: 'fixed' | 'sticky' | 'static' | 'absolute' | 'relative';
}

export const HeaderBar = ({ headerChildren, className, currentHeaderRef, id, position = 'fixed' }: HeaderBarProps) => {
  return (
    <AppBar position={position} color="inherit" elevation={0} className={className}>
      <Toolbar className="header-toolbar" disableGutters={true} ref={currentHeaderRef} id={id || 'global-header'}>
        {(headerChildren || []).map((row, rowIndex) => (
          <Box
            className="toolbar-box"
            // eslint-disable-next-line react/no-array-index-key
            key={'toolbar-box' + rowIndex}
          >
            {(Array.isArray(row) ? row : [row]).map((col, colIndex) => (
              // eslint-disable-next-line react/no-array-index-key
              <Fragment key={'header-col' + colIndex}>{col}</Fragment>
            ))}
          </Box>
        ))}
      </Toolbar>
    </AppBar>
  );
};
